<template>
  <div class="link__grid">
    <span>{{ page.name }}</span>
    <a :href="page.link" rel="external" target="_blank">
      <button class="btn btn__orange">Visit Page</button>
    </a>
    <button class="btn btn__orange" @click.prevent="copyText(page.id)">
      Copy Link
      <transition name="tooltip">
        <span v-if="copied === page.id" class="tooltip--text">copied to clipboard</span>
      </transition>
    </button>
    <input :id="page.id" class="hidden" type="text" :value="page.link" />
  </div>
</template>

<script>
export default {
  props: ["page", "copied"],
  methods: {
    copyText(id) {
      this.$emit("copyText", id);
    }
  }
};
</script>